import React from "react";
import GradeSessionsPage from "@/components/GradeSessionsPage";

const AGENDA = [
  { time: "7:30-8:30 am", label: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment" },
  { time: "8:30-9:15 am", label: "Keynote Speaker" },
  { time: "9:30-10:30 am", label: "Session 1" },
  { time: "10:45-11:45 am", label: "Session 2" },
  { time: "11:45 am - 1 pm", label: "Lunch" },
  { time: "1:15-2:15 pm", label: "Session 3" },
];

const KEYNOTE_SPEAKER = {
  name: "Kai Frazier",
  title: "CEO, Kai XR",
  photo: "/images/frazier.png",
  bio: `Kai Frazier is a teacher unapologetically dedicated to students. She has worked in education for over twenty years, striving to be a good steward of students' dreams, voices, creativity, and future. She created Kai XR to foster a culture of innovation where students develop critical thinking, collaboration, resilience, communication, and inclusivity. Kai XR serves as a safe and accessible space for all students to build these skills and create the world they envision. Over the past few years, she and her team have grown Kai XR into an all-in-one platform that helps educators expand student imagination while teaching essential 21st-century skills. She believes it is the collective responsibility of teachers, parents, and the community to nurture student imagination, as their ideas will shape the future.`,
};

const SESSIONS = [
  {
    title: "Magic School AI",
    description: `This interactive session provides educators with hands-on experience using MagicSchool AI to support daily classroom instruction and streamline teacher workflows. Participants will explore a variety of educator-focused AI tools designed to assist with lesson planning, instructional differentiation, assessment creation, rubric development, parent communication, and classroom engagement. Teachers will learn practical strategies for using AI to save time while maintaining high-quality, student-centered instruction.

Throughout the workshop, participants will have the opportunity to practice using MagicSchool AI tools in real classroom scenarios and create resources they can immediately implement in their classrooms. The session will also highlight responsible AI use, best practices for reviewing AI-generated content, and ways to align AI-supported instruction with district expectations and curriculum goals. By the end of the session, teachers will leave with practical tools and strategies to increase efficiency, personalize learning, and support student success.`,
  },
  {
    title: "Magma Math",
    description: `Teachers will explore Magma Math as a tool to strengthen mathematical discourse, formative assessment, and real-time feedback in elementary classrooms. The session will focus on using student work analysis and collaborative problem-solving to support conceptual understanding and standards mastery.`,
  },
  {
    title: "Social Studies Curriculum Overview",
    description: `3-5 teachers will explore the Cengage social studies curriculum with a focus on standards alignment, lesson design, and instructional pacing. Participants will examine strategies that support literacy, inquiry, and student engagement in history, civics, geography, and economics.`,
  },
];

export default function Sessions35() {
  return (
    <GradeSessionsPage
      testId="sessions-35-page"
      title="3-5 District PD Information"
      barColor="#541011"
      gradeBand="35"
      location={{
        name: "Carver High School",
        address: "3900 24th Street North, Birmingham, AL 35207",
      }}
      agenda={AGENDA}
      keynoteSpeaker={KEYNOTE_SPEAKER}
      sessionsList={SESSIONS}
      accessCode="VCJC-H4PV-NM7SZ"
      registrationNumber="344825"
    />
  );
}
